import * as React from 'react';
import {
  addControlColumn,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useCloneEntity,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { InstitutionMemberView, InstitutionMemberViewRow } from 'cb-model';
import { QueryOptions } from 'gossamer-unified';
import { useInstitutionFilter } from '../institution/useInstitutionFilter';
import { MemberRevokeMembershipButton } from './MemberRevokeMembershipButton';

export const VerifiedMemberSearch = (): React.JSX.Element => {
  const initialQueryOptions = useInstitutionFilter({
    where: {
      and: [
        { fieldId: 'institution_id', operator: 'eq', value: '', display: 'hidden' },
        { fieldId: 'email', operator: 'ct', value: '', display: 'value-edit' },
        { fieldId: 'is_admin', operator: 'eq', value: false, display: 'hidden' },
        { fieldId: 'is_verified', operator: 'eq', value: true, display: 'hidden' },
      ],
    },
    order: [['last_name', 'ASC']],
  } as QueryOptions);
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(InstitutionMemberView, initialQueryOptions);
  const LocalInstitutionMemberView = useCloneEntity(InstitutionMemberView, (local) => {
    local.fields.is_admin.listColumn = false;
    local.fields.is_verified.listColumn = false;
    addControlColumn(
      local,
      'revoke_membership',
      999,
      (row: InstitutionMemberViewRow) => String(row.institution_member_id),
      MemberRevokeMembershipButton,
    );
  });
  const gCacheQueryItem = useCacheQuery(LocalInstitutionMemberView, queryOptions);
  return (
    <Section subtitle="Users who can access private institution events">
      <PaginatorAndListSettings
        entity={LocalInstitutionMemberView}
        gCacheQuery={gCacheQueryItem}
        queryOptions={queryOptions}
        render={Search}
        setQueryOptions={setQueryOptions}
      />
    </Section>
  );
};
